// @flow
import React from 'react'
import { graphql } from 'gatsby'
import { Helmet } from 'react-helmet'
import { MDXRenderer } from 'gatsby-plugin-mdx'
import Layout from '../layout'
import Speakers from '../components/speakers'
import Attachments from '../components/attachments'
import { slidesLinkFor } from '../utils'

type Props = {
  data: {
    talk: {
      exports: {
        meta: {
          title: string,
          speakers: string[],
          hasSlides: ?boolean,
          tbd: boolean,
        },
      },
      body: string,
    },
  },
}

function Talk({ data }: Props) {
  const { talk } = data
  const { title, speakers, hasSlides, tbd } = talk.exports.meta
  const { body } = talk
  return (
    <Layout>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <h1>{title}</h1>
      {hasSlides ? (
        <Attachments
          list={[
            {
              name: 'See slides',
              file: slidesLinkFor(title),
              icon: 'file-presentation',
            },
          ]}
        />
      ) : null}
      {tbd ? (
        <p>Abstract is coming soon…</p>
      ) : (
        <MDXRenderer>{body}</MDXRenderer>
      )}
      <Speakers
        style={{ marginTop: '1.5rem' }}
        includeSpeakers={speakers}
        includeTbd
        hasBiography
      />
    </Layout>
  )
}

export default Talk

export const query = graphql`
  query Talk($id: String!) {
    talk: mdx(id: { eq: $id }) {
      exports {
        meta {
          title
          speakers
          hasSlides
          tbd
        }
      }
      body
    }
  }
`
